var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkTo)?_c('router-link',{staticClass:"topicChipLink",class:[_vm.status],attrs:{"to":_vm.linkTo}},[_c('md-chip',{staticClass:"topicChip"},[_vm._t("default")],2)],1):_c('md-chip',{staticClass:"topicChip",class:[_vm.status]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663544fc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/TopicChip.vue
// module id = 388
// module chunks = 0